
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Table,
} from "reactstrap";
import { fetchInterpreters } from "slices/interpreterSlice";
import { interpreterSelector } from "slices/interpreterSlice";

import Api from "services/api"
import AddInterpreter from "components/interpreter/AddInterpreter";
import { removeInterpreter } from "slices/interpreterSlice";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { SortButtons } from "components/common/SortButtons";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/interpreterSlice";
import { removeMultipleInterpreters } from "slices/interpreterSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { PAGELENGTH } from "components/common/ListLayout";
import { usePermissions } from "layouts/Admin";

const apiService = new Api();


function InterpreterList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { interpreter: interpreters, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(interpreterSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });


  React.useEffect(() => {
    dispatch(fetchInterpreters())
  }, [])

  const handleAddInterpreterPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchInterpreters())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleInterpreters({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(interpreters && interpreters?.map((interpreter) => interpreter.id.toString()))


  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchInterpreters(page));
  }, [])

  const handleClose = () => {
    // refAddutton.current.click(); 
    setAddForm({ show: false })
  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchInterpreters(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Interpreter') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th>
          <TableHeaderItem
            title="Interpreter Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Email"
            sortBy="email"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Interpreter') &&
          <th className="col-1">Status</th>
        }
        {checkPermission('Delete Interpreter') &&
          <th className="col-1">Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, interpreters]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      interpreters && interpreters?.map((interpreter, index) => (
        <InterpreterItem interpreter={interpreter} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddInterpreterPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [interpreters, selectedItems, current_page]);

  //#endregion


  return (
    <ListLayout
      heading="Interpreters"
      time={true}
      title=""
      buttonTitle="Add Interpreter"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchInterpreters}
      selectedItems={selectedItems}
      addButtonDisabled={!checkPermission('Add Interpreter')}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddInterpreter item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Interpreter')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddInterpreterPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search Interpreters ..."
      noOfItems={total}
    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const InterpreterItem = ({
  interpreter, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(interpreter?.user?.status == "active" ? 1 : 0 || 0);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  useEffect(() => {
    setStatus(
      interpreter?.user?.status
    )

  }, [interpreter]);

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);

  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Interpreter') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={interpreter.id} checked={selectedItems.includes(interpreter.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {interpreter.user.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {interpreter.user.email}
      </td>
      <td style={getBackgroundStyle(status)}>
        {convertTimeToUTC(interpreter.created_at)}
      </td>
      {checkPermission('Status Interpreter') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(interpreter?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {checkPermission('Edit Interpreter') &&
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...interpreter, status })}>Edit</button>
          </div>
        </td>
      }
    </tr>
  )
}


export default InterpreterList;
